"use strict";
// Stremio Plus: "Who's watching?" screen and profile management.
// Built from stock Stremio components (Settings sections/options, Toggle, MultiselectMenu)
// so it looks native. Opening a profile asks its PIN and stores the profile token the server
// requires for that profile's history, addons, PIN and recovery phrase.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_1 = require("react-router");
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var components_1 = require("stremio/components");
var common_1 = require("stremio/common");
var api_1 = __importDefault(require("stremio/plus/api"));
var activeProfile_1 = require("stremio/plus/activeProfile");
var profileStorage_1 = require("stremio/plus/profileStorage");
var kids_1 = require("stremio/plus/kids");
var ProfileAvatar_1 = __importDefault(require("./ProfileAvatar"));
var PinPrompt_1 = __importDefault(require("./PinPrompt"));
var RecoveryPhrase_1 = __importDefault(require("./RecoveryPhrase"));
var RecoveryForm_1 = __importDefault(require("./RecoveryForm"));
var OwnerPinSetup_1 = __importDefault(require("./OwnerPinSetup"));
var ProfileEditor_1 = __importDefault(require("./ProfileEditor"));
var ProfileGate_less_1 = __importDefault(require("./ProfileGate.less"));
var MAX_PROFILES = 5;
var toActiveProfile = function (profile, token, tokenExpiresAt) { return ({
    id: profile.id,
    name: profile.name,
    avatar: profile.avatar,
    isMain: profile.isMain,
    isKids: profile.isKids,
    maxAge: profile.maxAge,
    token: token,
    tokenExpiresAt: tokenExpiresAt,
}); };
// The worker and the storage keys only pick up these fields after a reload. A new token for the
// same profile does not need one while the worker's token is still valid.
var needsReload = function (current, next) {
    if (current === null || !(0, activeProfile_1.isUnlocked)(current))
        return true;
    return current.id !== next.id || current.isKids !== next.isKids || current.maxAge !== next.maxAge;
};
var ProfileGate = function () {
    var _a, _b, _c;
    var t = (0, react_i18next_1.useTranslation)().t;
    var ctxProfile = (0, common_1.useProfile)();
    var authKey = (_b = (_a = ctxProfile.auth) === null || _a === void 0 ? void 0 : _a.key) !== null && _b !== void 0 ? _b : null;
    var _d = (0, react_1.useState)(function () { return !(0, activeProfile_1.isProfileChosen)() || !(0, activeProfile_1.isUnlocked)((0, activeProfile_1.getActiveProfile)()); }), open = _d[0], setOpen = _d[1];
    var _e = (0, react_1.useState)({ type: 'pick' }), mode = _e[0], setMode = _e[1];
    var _f = (0, react_1.useState)(null), profiles = _f[0], setProfiles = _f[1];
    var _g = (0, react_1.useState)(null), error = _g[0], setError = _g[1];
    var current = (0, activeProfile_1.getActiveProfile)();
    var currentUnlocked = (0, activeProfile_1.isUnlocked)(current);
    var kidsActive = currentUnlocked && (current === null || current === void 0 ? void 0 : current.isKids) === true;
    var mainProfile = (_c = profiles === null || profiles === void 0 ? void 0 : profiles.find(function (_a) {
        var isMain = _a.isMain;
        return isMain;
    })) !== null && _c !== void 0 ? _c : null;
    var isOwner = currentUnlocked && (current === null || current === void 0 ? void 0 : current.isMain) === true;
    var canAdd = isOwner && profiles !== null && profiles.length < MAX_PROFILES;
    // The owner PIN protects addons and parental controls, so it is set before anything else.
    var ownerPinMissing = mainProfile !== null && !mainProfile.hasPin;
    (0, react_1.useEffect)(function () {
        if (ownerPinMissing)
            setOpen(true);
    }, [ownerPinMissing]);
    var location = (0, react_router_1.useLocation)();
    var navigate = (0, react_router_1.useNavigate)();
    (0, react_1.useEffect)(function () {
        if ((0, kids_1.isBlockedPath)(currentUnlocked ? current : null, location.pathname)) {
            navigate('/', { replace: true });
        }
    }, [current === null || current === void 0 ? void 0 : current.id, currentUnlocked, location.pathname]);
    var activate = (0, react_1.useCallback)(function (profile, token, expiresAt) {
        var previous = (0, activeProfile_1.getActiveProfile)();
        var next = toActiveProfile(profile, token, expiresAt);
        (0, activeProfile_1.setActiveProfile)(next);
        (0, activeProfile_1.setProfileChosen)(true);
        if (needsReload(previous, next)) {
            window.location.reload();
        }
        else {
            setOpen(false);
            setMode({ type: 'pick' });
        }
    }, []);
    var loadProfiles = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var list, previous_1, fresh, next, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (authKey === null)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, api_1.default.listProfiles(authKey)];
                case 2:
                    list = _a.sent();
                    setProfiles(list);
                    setError(null);
                    previous_1 = (0, activeProfile_1.getActiveProfile)();
                    fresh = list.find(function (_a) {
                        var id = _a.id;
                        return id === (previous_1 === null || previous_1 === void 0 ? void 0 : previous_1.id);
                    });
                    if (previous_1 !== null && fresh === undefined) {
                        // The profile was deleted elsewhere.
                        (0, activeProfile_1.setActiveProfile)(null);
                        (0, activeProfile_1.setProfileChosen)(false);
                        window.location.reload();
                    }
                    else if (previous_1 !== null && fresh !== undefined) {
                        next = toActiveProfile(fresh, previous_1.token, previous_1.tokenExpiresAt);
                        (0, activeProfile_1.setActiveProfile)(next);
                        if ((0, activeProfile_1.isUnlocked)(previous_1) && needsReload(previous_1, next))
                            window.location.reload();
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    setError(e_1.message);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [authKey]);
    (0, react_1.useEffect)(function () {
        if (authKey === null) {
            if ((0, activeProfile_1.getActiveProfile)() !== null) {
                (0, activeProfile_1.setActiveProfile)(null);
                (0, profileStorage_1.clearSecondaryProfilesStorage)();
            }
            (0, activeProfile_1.setProfileChosen)(false);
            setProfiles(null);
            return;
        }
        loadProfiles();
    }, [authKey, loadProfiles]);
    (0, react_1.useEffect)(function () {
        var onSwitch = function () {
            setMode({ type: 'pick' });
            setOpen(true);
            loadProfiles();
        };
        window.addEventListener(activeProfile_1.SWITCH_PROFILE_EVENT, onSwitch);
        return function () { return window.removeEventListener(activeProfile_1.SWITCH_PROFILE_EVENT, onSwitch); };
    }, [loadProfiles]);
    // After a PIN: PIN profiles from before recovery phrases get one, shown once, then open.
    var onUnlocked = (0, react_1.useCallback)(function (owner, target, result) { return __awaiter(void 0, void 0, void 0, function () {
        var unlocked, recoveryPhrase, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    if (!(target.id !== owner.id)) return [3 /*break*/, 2];
                    return [4 /*yield*/, api_1.default.unlock(authKey, target.id)];
                case 1:
                    unlocked = _a.sent();
                    if (unlocked.valid)
                        activate(target, unlocked.token, unlocked.expiresAt);
                    return [2 /*return*/];
                case 2:
                    if (!result.needsRecoveryPhrase) return [3 /*break*/, 4];
                    return [4 /*yield*/, api_1.default.regenerateRecoveryPhrase(authKey, result.token, target.id, result.pin)];
                case 3:
                    recoveryPhrase = (_a.sent()).recoveryPhrase;
                    setMode({ type: 'phrase', phrase: recoveryPhrase, profileName: target.name, then: function () { return activate(target, result.token, result.expiresAt); } });
                    return [2 /*return*/];
                case 4:
                    activate(target, result.token, result.expiresAt);
                    return [3 /*break*/, 6];
                case 5:
                    e_2 = _a.sent();
                    setError(e_2.message);
                    setMode({ type: 'pick' });
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [authKey, activate]);
    var openProfile = (0, react_1.useCallback)(function (profile) { return __awaiter(void 0, void 0, void 0, function () {
        var unlocked, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Back to the profile already unlocked on this device.
                    if (currentUnlocked && (current === null || current === void 0 ? void 0 : current.id) === profile.id && !profile.hasPin) {
                        setOpen(false);
                        return [2 /*return*/];
                    }
                    if (profile.hasPin) {
                        setMode({ type: 'unlock', profile: profile, target: profile });
                        return [2 /*return*/];
                    }
                    // Leaving a kids profile for a grown-up profile asks for the owner PIN.
                    if (kidsActive && !profile.isKids && (mainProfile === null || mainProfile === void 0 ? void 0 : mainProfile.hasPin)) {
                        setMode({ type: 'unlock', profile: mainProfile, target: profile });
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, api_1.default.unlock(authKey, profile.id)];
                case 2:
                    unlocked = _a.sent();
                    if (unlocked.valid)
                        activate(profile, unlocked.token, unlocked.expiresAt);
                    return [3 /*break*/, 4];
                case 3:
                    e_3 = _a.sent();
                    setError(e_3.message);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [authKey, current === null || current === void 0 ? void 0 : current.id, currentUnlocked, kidsActive, mainProfile, activate]);
    // Managing: yourself fully, or, as the owner, the others' parental controls and deletion.
    var canManage = (0, react_1.useCallback)(function (profile) {
        if (!currentUnlocked)
            return false;
        return profile.id === (current === null || current === void 0 ? void 0 : current.id) || isOwner;
    }, [currentUnlocked, current === null || current === void 0 ? void 0 : current.id, isOwner]);
    var onProfileClick = (0, react_1.useCallback)(function (profile) {
        if (mode.type === 'manage') {
            if (!canManage(profile))
                return;
            setMode({ type: 'edit', kind: profile.id === (current === null || current === void 0 ? void 0 : current.id) ? 'self' : 'admin', profile: profile });
            return;
        }
        openProfile(profile);
    }, [mode.type, canManage, current === null || current === void 0 ? void 0 : current.id, openProfile]);
    var onEditorDone = (0, react_1.useCallback)(function (deletedId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // Deleting the profile in use sends everyone back to the picker.
                    if (deletedId !== undefined && deletedId === ((_a = (0, activeProfile_1.getActiveProfile)()) === null || _a === void 0 ? void 0 : _a.id)) {
                        (0, activeProfile_1.setActiveProfile)(null);
                        (0, activeProfile_1.setProfileChosen)(false);
                        window.location.reload();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, loadProfiles()];
                case 1:
                    _b.sent();
                    setMode({ type: 'manage' });
                    return [2 /*return*/];
            }
        });
    }); }, [loadProfiles]);
    var onShowPhrase = (0, react_1.useCallback)(function (phrase, profileName, then) {
        setMode({ type: 'phrase', phrase: phrase, profileName: profileName, then: then });
    }, []);
    var onOwnerSetup = (0, react_1.useCallback)(function (_a) {
        var token = _a.token, expiresAt = _a.expiresAt, recoveryPhrase = _a.recoveryPhrase;
        var owner = __assign(__assign({}, mainProfile), { hasPin: true });
        setProfiles(function (list) { var _a; return (_a = list === null || list === void 0 ? void 0 : list.map(function (profile) { return profile.id === owner.id ? owner : profile; })) !== null && _a !== void 0 ? _a : null; });
        var finish = function () { return activate(owner, token, expiresAt); };
        if (recoveryPhrase) {
            setMode({ type: 'phrase', phrase: recoveryPhrase, profileName: owner.name, then: finish });
        }
        else {
            finish();
        }
    }, [mainProfile, activate]);
    if (authKey === null || !open)
        return null;
    var renderContent = function () {
        if (mode.type === 'phrase') {
            return react_1.default.createElement(RecoveryPhrase_1.default, { phrase: mode.phrase, profileName: mode.profileName, onDone: mode.then });
        }
        if (ownerPinMissing && mainProfile !== null) {
            return react_1.default.createElement(OwnerPinSetup_1.default, { authKey: authKey, profile: mainProfile, onDone: onOwnerSetup });
        }
        if (mode.type === 'unlock') {
            var profile_1 = mode.profile, target_1 = mode.target;
            return (react_1.default.createElement(PinPrompt_1.default, { authKey: authKey, profile: profile_1, onUnlocked: function (result) { return onUnlocked(profile_1, target_1, result); }, onCancel: function () { return setMode({ type: 'pick' }); }, onForgot: profile_1.id === target_1.id ? function () { return setMode({ type: 'forgot', profile: profile_1 }); } : undefined }));
        }
        if (mode.type === 'forgot') {
            var profile_2 = mode.profile;
            return (react_1.default.createElement(RecoveryForm_1.default, { authKey: authKey, profile: profile_2, onRecovered: function (token, expiresAt) { return activate(__assign(__assign({}, profile_2), { hasPin: true }), token, expiresAt); }, onCancel: function () { return setMode({ type: 'unlock', profile: profile_2, target: profile_2 }); } }));
        }
        if (mode.type === 'edit' && current !== null) {
            return (react_1.default.createElement(ProfileEditor_1.default, { kind: mode.kind, authKey: authKey, token: current.token, profile: mode.profile, mainHasPin: (mainProfile === null || mainProfile === void 0 ? void 0 : mainProfile.hasPin) === true, onDone: onEditorDone, onShowPhrase: onShowPhrase }));
        }
        return (react_1.default.createElement("div", { className: ProfileGate_less_1.default['picker'] },
            react_1.default.createElement("div", { className: ProfileGate_less_1.default['title'] }, mode.type === 'manage' ? t('PLUS_PROFILES_MANAGE') : t('PLUS_PROFILES_WHO')),
            error !== null ?
                react_1.default.createElement("div", { className: ProfileGate_less_1.default['error'] },
                    t('PLUS_PROFILES_LOAD_ERROR'),
                    " (",
                    error,
                    ")")
                :
                    null,
            react_1.default.createElement("div", { className: ProfileGate_less_1.default['profiles'] },
                (profiles !== null && profiles !== void 0 ? profiles : []).map(function (profile) {
                    var _a;
                    var locked = mode.type === 'manage' && !canManage(profile);
                    return (react_1.default.createElement(components_1.Button, { key: profile.id, className: (0, classnames_1.default)(ProfileGate_less_1.default['profile'], (_a = {}, _a[ProfileGate_less_1.default['managing']] = mode.type === 'manage', _a[ProfileGate_less_1.default['locked']] = locked, _a)), title: profile.name, disabled: locked, onClick: function () { return onProfileClick(profile); } },
                        react_1.default.createElement(ProfileAvatar_1.default, { profile: profile }),
                        react_1.default.createElement("div", { className: ProfileGate_less_1.default['name'] }, profile.name),
                        react_1.default.createElement("div", { className: ProfileGate_less_1.default['badges'] },
                            profile.isMain ? react_1.default.createElement("span", { className: ProfileGate_less_1.default['badge'] }, t('PLUS_PROFILES_OWNER')) : null,
                            profile.isKids ? react_1.default.createElement("span", { className: ProfileGate_less_1.default['badge'] }, t('PLUS_PROFILES_KIDS')) : null,
                            profile.hasPin ? react_1.default.createElement("span", { className: ProfileGate_less_1.default['badge'] }, t('PLUS_PROFILES_LOCKED')) : null)));
                }),
                canAdd && mode.type === 'manage' ?
                    react_1.default.createElement(components_1.Button, { className: ProfileGate_less_1.default['profile'], title: t('PLUS_PROFILES_ADD'), onClick: function () { return setMode({ type: 'edit', kind: 'create', profile: null }); } },
                        react_1.default.createElement("div", { className: (0, classnames_1.default)(ProfileGate_less_1.default['avatar'], ProfileGate_less_1.default['add']) }, "+"),
                        react_1.default.createElement("div", { className: ProfileGate_less_1.default['name'] }, t('PLUS_PROFILES_ADD')))
                    :
                        null),
            react_1.default.createElement("div", { className: ProfileGate_less_1.default['actions'] },
                error !== null ?
                    react_1.default.createElement(components_1.Button, { className: ProfileGate_less_1.default['button'], onClick: loadProfiles }, t('PLUS_PROFILES_RETRY'))
                    :
                        null,
                // Never lock the user out when the profiles backend is down (no history is shown then).
                error !== null && profiles === null ?
                    react_1.default.createElement(components_1.Button, { className: ProfileGate_less_1.default['button'], onClick: function () { (0, activeProfile_1.setProfileChosen)(true); setOpen(false); } }, t('PLUS_PROFILES_SKIP'))
                    :
                        null,
                // Managing needs an unlocked, grown-up profile.
                currentUnlocked && !kidsActive && profiles !== null ?
                    react_1.default.createElement(components_1.Button, { className: ProfileGate_less_1.default['button'], onClick: function () { return setMode({ type: mode.type === 'manage' ? 'pick' : 'manage' }); } }, mode.type === 'manage' ? t('PLUS_PROFILES_DONE') : t('PLUS_PROFILES_MANAGE'))
                    :
                        null,
                mode.type === 'pick' && (0, activeProfile_1.isProfileChosen)() && currentUnlocked ?
                    react_1.default.createElement(components_1.Button, { className: ProfileGate_less_1.default['button'], onClick: function () { return setOpen(false); } }, t('PLUS_PROFILES_CANCEL'))
                    :
                        null)));
    };
    return (react_1.default.createElement("div", { className: ProfileGate_less_1.default['profile-gate'] },
        react_1.default.createElement("div", { className: ProfileGate_less_1.default['background'] }),
        renderContent()));
};
exports.default = ProfileGate;
